/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/analytics_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1GetAgentDealsReportResponse } from '../models'
// @ts-ignore
import { V1GetAgentPresentationReportResponse } from '../models'
// @ts-ignore
import { V1GetAgentRewardReportResponse } from '../models'
// @ts-ignore
import { V1GetCampaignReportResponse } from '../models'
// @ts-ignore
import { V1GetClientSourceReportResponse } from '../models'
// @ts-ignore
import { V1GetClientsKpiResponse } from '../models'
// @ts-ignore
import { V1GetCompanyDealsReportResponse } from '../models'
// @ts-ignore
import { V1GetDashboardMetricsResponse } from '../models'
// @ts-ignore
import { V1GetDealsKpiResponse } from '../models'
// @ts-ignore
import { V1GetFunnelResponse } from '../models'
// @ts-ignore
import { V1GetLandingAttributionReportResponse } from '../models'
// @ts-ignore
import { V1GetLandingConversionReportResponse } from '../models'
// @ts-ignore
import { V1GetLandingDailySeriesResponse } from '../models'
// @ts-ignore
import { V1GetLandingEventsReportResponse } from '../models'
// @ts-ignore
import { V1GetLeadSourcesReportResponse } from '../models'
// @ts-ignore
import { V1GetManagerAnalyticsResponse } from '../models'
// @ts-ignore
import { V1GetManagerLeaderboardResponse } from '../models'
// @ts-ignore
import { V1GetRevenueReportResponse } from '../models'
// @ts-ignore
import { V1GetSalesFinanceReportResponse } from '../models'
// @ts-ignore
import { V1GetSalesInsightsResponse } from '../models'
// @ts-ignore
import { V1GetSalesReportResponse } from '../models'
// @ts-ignore
import { V1ListSalesTargetsResponse } from '../models'
// @ts-ignore
import { V1PresentationStatsResponse } from '../models'
// @ts-ignore
import { V1RunReconcileRequest } from '../models'
// @ts-ignore
import { V1RunReconcileResponse } from '../models'
// @ts-ignore
import { V1RunSalesExportNowResponse } from '../models'
// @ts-ignore
import { V1SalesExportSettings } from '../models'
// @ts-ignore
import { V1SalesReportSettings } from '../models'
// @ts-ignore
import { V1SalesTarget } from '../models'
// @ts-ignore
import { V1UpdateSalesExportSettingsRequest } from '../models'
// @ts-ignore
import { V1UpdateSalesReportSettingsRequest } from '../models'
// @ts-ignore
import { V1UpsertSalesTargetRequest } from '../models'
/**
 * AnalyticsServiceApi - axios parameter creator
 * @export
 */
export const AnalyticsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Removes a goal.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceDeleteSalesTarget: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('analyticsServiceDeleteSalesTarget', 'id', id)
      const localVarPath = `/api/v1/analytics/reports/sales/finance/targets/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns per-agent sales figures: clients, deals, wins, deposits, client-to-deposit conversion, revenue and the forecast reward.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentDealsReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/agent-deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators, the head of sales and the CEO see every agent; a manager sees only the agents they supervise.
     * @summary Returns presentation statistics for every visible agent at once: one row per agent plus the combined totals and daily trend.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/agent-presentations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators, the head of sales and the CEO may request any agent; a manager only the agents they supervise.
     * @summary Returns the same presentation statistics for one named agent, as shown on the agent card in the CRM.
     * @param {string} agentId
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationStats: async (
      agentId: string,
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'agentId' is not null or undefined
      assertParamExists('analyticsServiceGetAgentPresentationStats', 'agentId', agentId)
      const localVarPath = `/api/v1/analytics/reports/agent-presentations/{agentId}`.replace(
        `{${'agentId'}}`,
        encodeURIComponent(String(agentId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns agent deals grouped by the state of their reward — expected, approved, paid, disputed or cancelled — with the forecast amount.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentRewardReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/agent-reward`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * This is what a campaign card shows next to its links, so it is readable by whoever runs the campaigns — not only by the roles that see the full marketing report. Internal note: requires landings:read.
     * @summary Returns every campaign with its tagged links, each with its own views and leads.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [campaign] Empty means every campaign seen in the facts; a value narrows it to one.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetCampaignReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      campaign?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/campaigns`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (campaign !== undefined) {
        localVarQueryParameter['campaign'] = campaign
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns how well each way of acquiring a client performs: clients, deals, wins and conversion per source type.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientSourceReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/client-source`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the KPIs of the clients screen: totals, new clients, how many have an active deal and how many have no manager assigned.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientsKpi: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/clients-kpi`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns the same sales figures aggregated per partner company, with the number of agents each company contributed.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetCompanyDealsReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/company-deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: DEV-280 replaced three fan-out calls and an N+1 on the lead-source donut with this method.
     * @summary Returns every dashboard metric in one call: headline KPIs for clients, listings, deals and conversion, their sparklines, the lead-source breakdown and the monthly deal chart.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDashboardMetrics: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/dashboard`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the KPIs of the deals screen, including the per-stage breakdown the kanban board uses for its column headers.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDealsKpi: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/deals-kpi`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the sales funnel: how many deals reached each stage in the period, and the conversion between stages.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetFunnel: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/funnel`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Answers the question the report above cannot: not \"how many came from Telegram\" but \"which of the three campaigns worked\". Internal note: restricted to the same roles as the conversion report.
     * @summary Breaks one landing page down by the campaign tags its traffic arrived with.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once, which is how one campaign spread over several pages is read.
     * @param {string} [groupBy] Which tag the rows are grouped by: \&quot;source\&quot;, \&quot;medium\&quot;, \&quot;campaign\&quot; or \&quot;content\&quot; — the utm_* parameter without its prefix. Empty means \&quot;source\&quot;, which is what a campaign is read by first. Spelled as a string for the same reason PeriodFilter.period is: this contract has no enums.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingAttributionReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      groupBy?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/landings/attribution`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (landingSlug !== undefined) {
        localVarQueryParameter['landingSlug'] = landingSlug
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * This is a report about a shared marketing asset, so it carries no per-manager scope. Internal note: restricted to administrators, the head of sales and the CEO.
     * @summary Returns leads against page views for every landing page in the period.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingConversionReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/landings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Days are cut in Asia/Ho_Chi_Minh, where the traffic is: in UTC an evening campaign would land half in one day and half in the next. Internal note: restricted to the same roles as the conversion report.
     * @summary Returns views and leads day by day, so that a spike has a shape and a date instead of being a single number for the whole period.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once.
     * @param {string} [campaign] Empty means every campaign at once; a value narrows the series down to one utm_campaign, which is how a campaign card draws its own traffic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingDailySeries: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      campaign?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/landings/daily`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (landingSlug !== undefined) {
        localVarQueryParameter['landingSlug'] = landingSlug
      }

      if (campaign !== undefined) {
        localVarQueryParameter['campaign'] = campaign
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Answers what a view count cannot: a page nobody scrolls past the first screen and a page everyone reads to the end have the same views. Internal note: counters of one\'s own page, so requires landings:read — the same level as the campaign report.
     * @summary Returns what visitors did on a landing page: how far they scrolled, what they tapped, how often they sent the form.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once.
     * @param {string} [campaign] Empty means every campaign at once; a value narrows the counts down to one utm_campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingEventsReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      campaign?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/landings/events`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (landingSlug !== undefined) {
        localVarQueryParameter['landingSlug'] = landingSlug
      }

      if (campaign !== undefined) {
        localVarQueryParameter['campaign'] = campaign
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns how clients, deals and revenue are distributed across lead sources.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLeadSourcesReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Rows carry manager identifiers only — resolve the names through the auth service. Internal note: restricted to the head of sales and administrators.
     * @summary Returns how managers work rather than how much they sell: which funnel stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
     * @param {string} [from] Start of the window. Empty means no lower bound.
     * @param {string} [to] End of the window. Empty means no upper bound.
     * @param {Array<string>} [managerIds] Managers to include. Empty means every manager the caller may see.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerAnalytics: async (
      from?: string,
      to?: string,
      managerIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/manager-analytics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      if (managerIds) {
        localVarQueryParameter['managerIds'] = managerIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Ranks managers by won deals, win rate and revenue.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerLeaderboard: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/manager-leaderboard`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns presentation statistics for the calling agent: how many were created, sent and viewed, the conversion between sent and viewed, the daily trend and the best performing presentations.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetMyPresentationStats: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/presentations/my`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns revenue from won deals, grouped by time bucket, by manager or by lead source.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [groupBy] Grouping: a time bucket (\&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;) or a category (\&quot;manager\&quot;, \&quot;lead_source\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetRevenueReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      groupBy?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/revenue`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: readable by everyone who can read the report itself.
     * @summary Returns where the sales report is exported to, how often, and how the last export ended.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesExportSettings: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales/export-settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Money is not recomputed here. Every reward is already calculated in the deals service and travels through as is, so the card of a deal and this report can never disagree. Internal note: DEV-1880, ADR-0052; restricted to the head of sales, administrators and the CEO.
     * @summary Returns the \"Deals and revenue\" report: the plan and the fact of one month inside a target period, the same numbers week by week, and the deals they are made of.
     * @param {string} [month] Any moment inside the month. Empty means the current one.
     * @param {boolean} [includeExcluded] Count the deals of managers kept out of payroll — the leadership. They are left out by default, exactly as in the manual report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesFinanceReport: async (
      month?: string,
      includeExcluded?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales/finance`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (month !== undefined) {
        localVarQueryParameter['month'] =
          (month as any) instanceof Date ? (month as any).toISOString() : month
      }

      if (includeExcluded !== undefined) {
        localVarQueryParameter['includeExcluded'] = includeExcluded
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * It is a separate call rather than a block of the report because generation takes seconds to tens of seconds, and the screen must not wait for it. Internal note: restricted to the head of sales, administrators and the CEO.
     * @summary Returns a short written conclusion — four to six findings a model draws from the same aggregates the sales report is built on.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {boolean} [refresh] Generate again even when a conclusion for these numbers already exists. This backs the \&quot;refresh\&quot; button: the numbers are the same, but the wording may be worth another try.
     * @param {boolean} [cacheOnly] Answer from the cache only, never call the model. Exports run under their own deadline: waiting for a fresh conclusion would cost them the file, so they take the cached one or go without the block.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesInsights: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      refresh?: boolean,
      cacheOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales/insights`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (refresh !== undefined) {
        localVarQueryParameter['refresh'] = refresh
      }

      if (cacheOnly !== undefined) {
        localVarQueryParameter['cacheOnly'] = cacheOnly
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: DEV-1067 and ADR-0034 describe the classification; restricted to the head of sales, administrators and the CEO.
     * @summary Returns the sales department report: how leads are distributed across states, how the flow changed month over month, which sources performed, and how good the leads coming from agents were.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns how the report shows money: the currency and the rate used to compare a goal in dollars with revenue in dong.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesReportSettings: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales/finance/settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the sales goals, newest period first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceListSalesTargets: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales/finance/targets`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The run is idempotent and asynchronous: the call returns as soon as the reconciliation starts, and reads the source services under the caller\'s own token. Internal note: restricted to the head of sales and administrators.
     * @summary Rebuilds the read model from the source services.
     * @param {V1RunReconcileRequest} body What to reconcile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceRunReconcile: async (
      body: V1RunReconcileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('analyticsServiceRunReconcile', 'body', body)
      const localVarPath = `/api/v1/analytics/reconcile`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Asynchronous: building the file with its written conclusion and uploading it does not fit into the gateway timeout, so the call returns immediately and the outcome is read back from the export settings.
     * @summary Starts an export outside the schedule.
     * @param {object} body Empty: an unscheduled export takes no arguments and uses the stored settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceRunSalesExportNow: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('analyticsServiceRunSalesExportNow', 'body', body)
      const localVarPath = `/api/v1/analytics/reports/sales/export-settings/run`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to administrators and the head of sales, because the setting decides where company data leaves for.
     * @summary Changes the export destination folder, the schedule, the data window, or switches the export off.
     * @param {V1UpdateSalesExportSettingsRequest} body New export settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceUpdateSalesExportSettings: async (
      body: V1UpdateSalesExportSettingsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('analyticsServiceUpdateSalesExportSettings', 'body', body)
      const localVarPath = `/api/v1/analytics/reports/sales/export-settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replaces those settings.
     * @param {V1UpdateSalesReportSettingsRequest} body New display settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceUpdateSalesReportSettings: async (
      body: V1UpdateSalesReportSettingsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('analyticsServiceUpdateSalesReportSettings', 'body', body)
      const localVarPath = `/api/v1/analytics/reports/sales/finance/settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a goal, or rewrites the amount of the goal that already covers the same dates.
     * @param {V1UpsertSalesTargetRequest} body A goal to add, or to rewrite if one already covers the same dates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceUpsertSalesTarget: async (
      body: V1UpsertSalesTargetRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('analyticsServiceUpsertSalesTarget', 'body', body)
      const localVarPath = `/api/v1/analytics/reports/sales/finance/targets`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AnalyticsServiceApi - functional programming interface
 * @export
 */
export const AnalyticsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AnalyticsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Removes a goal.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceDeleteSalesTarget(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceDeleteSalesTarget(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceDeleteSalesTarget']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns per-agent sales figures: clients, deals, wins, deposits, client-to-deposit conversion, revenue and the forecast reward.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentDealsReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetAgentDealsReport(
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentDealsReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators, the head of sales and the CEO see every agent; a manager sees only the agents they supervise.
     * @summary Returns presentation statistics for every visible agent at once: one row per agent plus the combined totals and daily trend.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentPresentationReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetAgentPresentationReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetAgentPresentationReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentPresentationReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators, the head of sales and the CEO may request any agent; a manager only the agents they supervise.
     * @summary Returns the same presentation statistics for one named agent, as shown on the agent card in the CRM.
     * @param {string} agentId
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentPresentationStats(
      agentId: string,
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PresentationStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetAgentPresentationStats(
          agentId,
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentPresentationStats']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns agent deals grouped by the state of their reward — expected, approved, paid, disputed or cancelled — with the forecast amount.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentRewardReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentRewardReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetAgentRewardReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentRewardReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * This is what a campaign card shows next to its links, so it is readable by whoever runs the campaigns — not only by the roles that see the full marketing report. Internal note: requires landings:read.
     * @summary Returns every campaign with its tagged links, each with its own views and leads.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [campaign] Empty means every campaign seen in the facts; a value narrows it to one.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetCampaignReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      campaign?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetCampaignReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetCampaignReport(
        periodPeriod,
        periodFrom,
        periodTo,
        campaign,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetCampaignReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns how well each way of acquiring a client performs: clients, deals, wins and conversion per source type.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetClientSourceReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetClientSourceReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetClientSourceReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetClientSourceReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the KPIs of the clients screen: totals, new clients, how many have an active deal and how many have no manager assigned.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetClientsKpi(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetClientsKpiResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetClientsKpi(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetClientsKpi']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns the same sales figures aggregated per partner company, with the number of agents each company contributed.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetCompanyDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetCompanyDealsReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetCompanyDealsReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetCompanyDealsReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: DEV-280 replaced three fan-out calls and an N+1 on the lead-source donut with this method.
     * @summary Returns every dashboard metric in one call: headline KPIs for clients, listings, deals and conversion, their sparklines, the lead-source breakdown and the monthly deal chart.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetDashboardMetrics(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDashboardMetricsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetDashboardMetrics(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the KPIs of the deals screen, including the per-stage breakdown the kanban board uses for its column headers.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetDealsKpi(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealsKpiResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetDealsKpi(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetDealsKpi']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the sales funnel: how many deals reached each stage in the period, and the conversion between stages.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetFunnel(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetFunnelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetFunnel(
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetFunnel']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Answers the question the report above cannot: not \"how many came from Telegram\" but \"which of the three campaigns worked\". Internal note: restricted to the same roles as the conversion report.
     * @summary Breaks one landing page down by the campaign tags its traffic arrived with.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once, which is how one campaign spread over several pages is read.
     * @param {string} [groupBy] Which tag the rows are grouped by: \&quot;source\&quot;, \&quot;medium\&quot;, \&quot;campaign\&quot; or \&quot;content\&quot; — the utm_* parameter without its prefix. Empty means \&quot;source\&quot;, which is what a campaign is read by first. Spelled as a string for the same reason PeriodFilter.period is: this contract has no enums.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLandingAttributionReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      groupBy?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetLandingAttributionReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLandingAttributionReport(
          periodPeriod,
          periodFrom,
          periodTo,
          landingSlug,
          groupBy,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLandingAttributionReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * This is a report about a shared marketing asset, so it carries no per-manager scope. Internal note: restricted to administrators, the head of sales and the CEO.
     * @summary Returns leads against page views for every landing page in the period.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLandingConversionReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetLandingConversionReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLandingConversionReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLandingConversionReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Days are cut in Asia/Ho_Chi_Minh, where the traffic is: in UTC an evening campaign would land half in one day and half in the next. Internal note: restricted to the same roles as the conversion report.
     * @summary Returns views and leads day by day, so that a spike has a shape and a date instead of being a single number for the whole period.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once.
     * @param {string} [campaign] Empty means every campaign at once; a value narrows the series down to one utm_campaign, which is how a campaign card draws its own traffic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLandingDailySeries(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      campaign?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingDailySeriesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLandingDailySeries(
          periodPeriod,
          periodFrom,
          periodTo,
          landingSlug,
          campaign,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLandingDailySeries']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Answers what a view count cannot: a page nobody scrolls past the first screen and a page everyone reads to the end have the same views. Internal note: counters of one\'s own page, so requires landings:read — the same level as the campaign report.
     * @summary Returns what visitors did on a landing page: how far they scrolled, what they tapped, how often they sent the form.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once.
     * @param {string} [campaign] Empty means every campaign at once; a value narrows the counts down to one utm_campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLandingEventsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      campaign?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingEventsReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLandingEventsReport(
          periodPeriod,
          periodFrom,
          periodTo,
          landingSlug,
          campaign,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLandingEventsReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns how clients, deals and revenue are distributed across lead sources.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLeadSourcesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLeadSourcesReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLeadSourcesReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLeadSourcesReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Rows carry manager identifiers only — resolve the names through the auth service. Internal note: restricted to the head of sales and administrators.
     * @summary Returns how managers work rather than how much they sell: which funnel stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
     * @param {string} [from] Start of the window. Empty means no lower bound.
     * @param {string} [to] End of the window. Empty means no upper bound.
     * @param {Array<string>} [managerIds] Managers to include. Empty means every manager the caller may see.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetManagerAnalytics(
      from?: string,
      to?: string,
      managerIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagerAnalyticsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetManagerAnalytics(
        from,
        to,
        managerIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetManagerAnalytics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Ranks managers by won deals, win rate and revenue.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetManagerLeaderboard(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagerLeaderboardResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetManagerLeaderboard(
          periodPeriod,
          periodFrom,
          periodTo,
          paginationPage,
          paginationPerPage,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetManagerLeaderboard']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns presentation statistics for the calling agent: how many were created, sent and viewed, the conversion between sent and viewed, the daily trend and the best performing presentations.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetMyPresentationStats(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PresentationStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetMyPresentationStats(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetMyPresentationStats']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns revenue from won deals, grouped by time bucket, by manager or by lead source.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [groupBy] Grouping: a time bucket (\&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;) or a category (\&quot;manager\&quot;, \&quot;lead_source\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetRevenueReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      groupBy?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetRevenueReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetRevenueReport(
        periodPeriod,
        periodFrom,
        periodTo,
        groupBy,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetRevenueReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: readable by everyone who can read the report itself.
     * @summary Returns where the sales report is exported to, how often, and how the last export ended.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetSalesExportSettings(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SalesExportSettings>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetSalesExportSettings(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetSalesExportSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Money is not recomputed here. Every reward is already calculated in the deals service and travels through as is, so the card of a deal and this report can never disagree. Internal note: DEV-1880, ADR-0052; restricted to the head of sales, administrators and the CEO.
     * @summary Returns the \"Deals and revenue\" report: the plan and the fact of one month inside a target period, the same numbers week by week, and the deals they are made of.
     * @param {string} [month] Any moment inside the month. Empty means the current one.
     * @param {boolean} [includeExcluded] Count the deals of managers kept out of payroll — the leadership. They are left out by default, exactly as in the manual report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetSalesFinanceReport(
      month?: string,
      includeExcluded?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetSalesFinanceReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetSalesFinanceReport(
          month,
          includeExcluded,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetSalesFinanceReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * It is a separate call rather than a block of the report because generation takes seconds to tens of seconds, and the screen must not wait for it. Internal note: restricted to the head of sales, administrators and the CEO.
     * @summary Returns a short written conclusion — four to six findings a model draws from the same aggregates the sales report is built on.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {boolean} [refresh] Generate again even when a conclusion for these numbers already exists. This backs the \&quot;refresh\&quot; button: the numbers are the same, but the wording may be worth another try.
     * @param {boolean} [cacheOnly] Answer from the cache only, never call the model. Exports run under their own deadline: waiting for a fresh conclusion would cost them the file, so they take the cached one or go without the block.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetSalesInsights(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      refresh?: boolean,
      cacheOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetSalesInsightsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetSalesInsights(
        periodPeriod,
        periodFrom,
        periodTo,
        refresh,
        cacheOnly,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetSalesInsights']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: DEV-1067 and ADR-0034 describe the classification; restricted to the head of sales, administrators and the CEO.
     * @summary Returns the sales department report: how leads are distributed across states, how the flow changed month over month, which sources performed, and how good the leads coming from agents were.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetSalesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetSalesReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetSalesReport(
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetSalesReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns how the report shows money: the currency and the rate used to compare a goal in dollars with revenue in dong.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetSalesReportSettings(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SalesReportSettings>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetSalesReportSettings(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetSalesReportSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the sales goals, newest period first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceListSalesTargets(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListSalesTargetsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceListSalesTargets(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceListSalesTargets']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * The run is idempotent and asynchronous: the call returns as soon as the reconciliation starts, and reads the source services under the caller\'s own token. Internal note: restricted to the head of sales and administrators.
     * @summary Rebuilds the read model from the source services.
     * @param {V1RunReconcileRequest} body What to reconcile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceRunReconcile(
      body: V1RunReconcileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RunReconcileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceRunReconcile(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceRunReconcile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Asynchronous: building the file with its written conclusion and uploading it does not fit into the gateway timeout, so the call returns immediately and the outcome is read back from the export settings.
     * @summary Starts an export outside the schedule.
     * @param {object} body Empty: an unscheduled export takes no arguments and uses the stored settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceRunSalesExportNow(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RunSalesExportNowResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceRunSalesExportNow(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceRunSalesExportNow']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to administrators and the head of sales, because the setting decides where company data leaves for.
     * @summary Changes the export destination folder, the schedule, the data window, or switches the export off.
     * @param {V1UpdateSalesExportSettingsRequest} body New export settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceUpdateSalesExportSettings(
      body: V1UpdateSalesExportSettingsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SalesExportSettings>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceUpdateSalesExportSettings(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceUpdateSalesExportSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replaces those settings.
     * @param {V1UpdateSalesReportSettingsRequest} body New display settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceUpdateSalesReportSettings(
      body: V1UpdateSalesReportSettingsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SalesReportSettings>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceUpdateSalesReportSettings(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceUpdateSalesReportSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a goal, or rewrites the amount of the goal that already covers the same dates.
     * @param {V1UpsertSalesTargetRequest} body A goal to add, or to rewrite if one already covers the same dates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceUpsertSalesTarget(
      body: V1UpsertSalesTargetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SalesTarget>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceUpsertSalesTarget(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceUpsertSalesTarget']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AnalyticsServiceApi - factory interface
 * @export
 */
export const AnalyticsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AnalyticsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Removes a goal.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceDeleteSalesTarget(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .analyticsServiceDeleteSalesTarget(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns per-agent sales figures: clients, deals, wins, deposits, client-to-deposit conversion, revenue and the forecast reward.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentDealsReportResponse> {
      return localVarFp
        .analyticsServiceGetAgentDealsReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators, the head of sales and the CEO see every agent; a manager sees only the agents they supervise.
     * @summary Returns presentation statistics for every visible agent at once: one row per agent plus the combined totals and daily trend.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentPresentationReportResponse> {
      return localVarFp
        .analyticsServiceGetAgentPresentationReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators, the head of sales and the CEO may request any agent; a manager only the agents they supervise.
     * @summary Returns the same presentation statistics for one named agent, as shown on the agent card in the CRM.
     * @param {string} agentId
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationStats(
      agentId: string,
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1PresentationStatsResponse> {
      return localVarFp
        .analyticsServiceGetAgentPresentationStats(
          agentId,
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns agent deals grouped by the state of their reward — expected, approved, paid, disputed or cancelled — with the forecast amount.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentRewardReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentRewardReportResponse> {
      return localVarFp
        .analyticsServiceGetAgentRewardReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * This is what a campaign card shows next to its links, so it is readable by whoever runs the campaigns — not only by the roles that see the full marketing report. Internal note: requires landings:read.
     * @summary Returns every campaign with its tagged links, each with its own views and leads.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [campaign] Empty means every campaign seen in the facts; a value narrows it to one.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetCampaignReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      campaign?: string,
      options?: any,
    ): AxiosPromise<V1GetCampaignReportResponse> {
      return localVarFp
        .analyticsServiceGetCampaignReport(periodPeriod, periodFrom, periodTo, campaign, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns how well each way of acquiring a client performs: clients, deals, wins and conversion per source type.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientSourceReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetClientSourceReportResponse> {
      return localVarFp
        .analyticsServiceGetClientSourceReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the KPIs of the clients screen: totals, new clients, how many have an active deal and how many have no manager assigned.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientsKpi(
      period?: string,
      options?: any,
    ): AxiosPromise<V1GetClientsKpiResponse> {
      return localVarFp
        .analyticsServiceGetClientsKpi(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns the same sales figures aggregated per partner company, with the number of agents each company contributed.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetCompanyDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetCompanyDealsReportResponse> {
      return localVarFp
        .analyticsServiceGetCompanyDealsReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: DEV-280 replaced three fan-out calls and an N+1 on the lead-source donut with this method.
     * @summary Returns every dashboard metric in one call: headline KPIs for clients, listings, deals and conversion, their sparklines, the lead-source breakdown and the monthly deal chart.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDashboardMetrics(
      period?: string,
      options?: any,
    ): AxiosPromise<V1GetDashboardMetricsResponse> {
      return localVarFp
        .analyticsServiceGetDashboardMetrics(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the KPIs of the deals screen, including the per-stage breakdown the kanban board uses for its column headers.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDealsKpi(
      period?: string,
      options?: any,
    ): AxiosPromise<V1GetDealsKpiResponse> {
      return localVarFp
        .analyticsServiceGetDealsKpi(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the sales funnel: how many deals reached each stage in the period, and the conversion between stages.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetFunnel(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetFunnelResponse> {
      return localVarFp
        .analyticsServiceGetFunnel(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Answers the question the report above cannot: not \"how many came from Telegram\" but \"which of the three campaigns worked\". Internal note: restricted to the same roles as the conversion report.
     * @summary Breaks one landing page down by the campaign tags its traffic arrived with.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once, which is how one campaign spread over several pages is read.
     * @param {string} [groupBy] Which tag the rows are grouped by: \&quot;source\&quot;, \&quot;medium\&quot;, \&quot;campaign\&quot; or \&quot;content\&quot; — the utm_* parameter without its prefix. Empty means \&quot;source\&quot;, which is what a campaign is read by first. Spelled as a string for the same reason PeriodFilter.period is: this contract has no enums.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingAttributionReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      groupBy?: string,
      options?: any,
    ): AxiosPromise<V1GetLandingAttributionReportResponse> {
      return localVarFp
        .analyticsServiceGetLandingAttributionReport(
          periodPeriod,
          periodFrom,
          periodTo,
          landingSlug,
          groupBy,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * This is a report about a shared marketing asset, so it carries no per-manager scope. Internal note: restricted to administrators, the head of sales and the CEO.
     * @summary Returns leads against page views for every landing page in the period.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingConversionReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetLandingConversionReportResponse> {
      return localVarFp
        .analyticsServiceGetLandingConversionReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Days are cut in Asia/Ho_Chi_Minh, where the traffic is: in UTC an evening campaign would land half in one day and half in the next. Internal note: restricted to the same roles as the conversion report.
     * @summary Returns views and leads day by day, so that a spike has a shape and a date instead of being a single number for the whole period.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once.
     * @param {string} [campaign] Empty means every campaign at once; a value narrows the series down to one utm_campaign, which is how a campaign card draws its own traffic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingDailySeries(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      campaign?: string,
      options?: any,
    ): AxiosPromise<V1GetLandingDailySeriesResponse> {
      return localVarFp
        .analyticsServiceGetLandingDailySeries(
          periodPeriod,
          periodFrom,
          periodTo,
          landingSlug,
          campaign,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Answers what a view count cannot: a page nobody scrolls past the first screen and a page everyone reads to the end have the same views. Internal note: counters of one\'s own page, so requires landings:read — the same level as the campaign report.
     * @summary Returns what visitors did on a landing page: how far they scrolled, what they tapped, how often they sent the form.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [landingSlug] Empty means every landing page at once.
     * @param {string} [campaign] Empty means every campaign at once; a value narrows the counts down to one utm_campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingEventsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      landingSlug?: string,
      campaign?: string,
      options?: any,
    ): AxiosPromise<V1GetLandingEventsReportResponse> {
      return localVarFp
        .analyticsServiceGetLandingEventsReport(
          periodPeriod,
          periodFrom,
          periodTo,
          landingSlug,
          campaign,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns how clients, deals and revenue are distributed across lead sources.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLeadSourcesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetLeadSourcesReportResponse> {
      return localVarFp
        .analyticsServiceGetLeadSourcesReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Rows carry manager identifiers only — resolve the names through the auth service. Internal note: restricted to the head of sales and administrators.
     * @summary Returns how managers work rather than how much they sell: which funnel stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
     * @param {string} [from] Start of the window. Empty means no lower bound.
     * @param {string} [to] End of the window. Empty means no upper bound.
     * @param {Array<string>} [managerIds] Managers to include. Empty means every manager the caller may see.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerAnalytics(
      from?: string,
      to?: string,
      managerIds?: Array<string>,
      options?: any,
    ): AxiosPromise<V1GetManagerAnalyticsResponse> {
      return localVarFp
        .analyticsServiceGetManagerAnalytics(from, to, managerIds, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Ranks managers by won deals, win rate and revenue.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerLeaderboard(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<V1GetManagerLeaderboardResponse> {
      return localVarFp
        .analyticsServiceGetManagerLeaderboard(
          periodPeriod,
          periodFrom,
          periodTo,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns presentation statistics for the calling agent: how many were created, sent and viewed, the conversion between sent and viewed, the daily trend and the best performing presentations.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetMyPresentationStats(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1PresentationStatsResponse> {
      return localVarFp
        .analyticsServiceGetMyPresentationStats(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns revenue from won deals, grouped by time bucket, by manager or by lead source.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [groupBy] Grouping: a time bucket (\&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;) or a category (\&quot;manager\&quot;, \&quot;lead_source\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetRevenueReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      groupBy?: string,
      options?: any,
    ): AxiosPromise<V1GetRevenueReportResponse> {
      return localVarFp
        .analyticsServiceGetRevenueReport(periodPeriod, periodFrom, periodTo, groupBy, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: readable by everyone who can read the report itself.
     * @summary Returns where the sales report is exported to, how often, and how the last export ended.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesExportSettings(options?: any): AxiosPromise<V1SalesExportSettings> {
      return localVarFp
        .analyticsServiceGetSalesExportSettings(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Money is not recomputed here. Every reward is already calculated in the deals service and travels through as is, so the card of a deal and this report can never disagree. Internal note: DEV-1880, ADR-0052; restricted to the head of sales, administrators and the CEO.
     * @summary Returns the \"Deals and revenue\" report: the plan and the fact of one month inside a target period, the same numbers week by week, and the deals they are made of.
     * @param {string} [month] Any moment inside the month. Empty means the current one.
     * @param {boolean} [includeExcluded] Count the deals of managers kept out of payroll — the leadership. They are left out by default, exactly as in the manual report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesFinanceReport(
      month?: string,
      includeExcluded?: boolean,
      options?: any,
    ): AxiosPromise<V1GetSalesFinanceReportResponse> {
      return localVarFp
        .analyticsServiceGetSalesFinanceReport(month, includeExcluded, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * It is a separate call rather than a block of the report because generation takes seconds to tens of seconds, and the screen must not wait for it. Internal note: restricted to the head of sales, administrators and the CEO.
     * @summary Returns a short written conclusion — four to six findings a model draws from the same aggregates the sales report is built on.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {boolean} [refresh] Generate again even when a conclusion for these numbers already exists. This backs the \&quot;refresh\&quot; button: the numbers are the same, but the wording may be worth another try.
     * @param {boolean} [cacheOnly] Answer from the cache only, never call the model. Exports run under their own deadline: waiting for a fresh conclusion would cost them the file, so they take the cached one or go without the block.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesInsights(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      refresh?: boolean,
      cacheOnly?: boolean,
      options?: any,
    ): AxiosPromise<V1GetSalesInsightsResponse> {
      return localVarFp
        .analyticsServiceGetSalesInsights(
          periodPeriod,
          periodFrom,
          periodTo,
          refresh,
          cacheOnly,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: DEV-1067 and ADR-0034 describe the classification; restricted to the head of sales, administrators and the CEO.
     * @summary Returns the sales department report: how leads are distributed across states, how the flow changed month over month, which sources performed, and how good the leads coming from agents were.
     * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetSalesReportResponse> {
      return localVarFp
        .analyticsServiceGetSalesReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns how the report shows money: the currency and the rate used to compare a goal in dollars with revenue in dong.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesReportSettings(options?: any): AxiosPromise<V1SalesReportSettings> {
      return localVarFp
        .analyticsServiceGetSalesReportSettings(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the sales goals, newest period first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceListSalesTargets(options?: any): AxiosPromise<V1ListSalesTargetsResponse> {
      return localVarFp
        .analyticsServiceListSalesTargets(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * The run is idempotent and asynchronous: the call returns as soon as the reconciliation starts, and reads the source services under the caller\'s own token. Internal note: restricted to the head of sales and administrators.
     * @summary Rebuilds the read model from the source services.
     * @param {V1RunReconcileRequest} body What to reconcile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceRunReconcile(
      body: V1RunReconcileRequest,
      options?: any,
    ): AxiosPromise<V1RunReconcileResponse> {
      return localVarFp
        .analyticsServiceRunReconcile(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Asynchronous: building the file with its written conclusion and uploading it does not fit into the gateway timeout, so the call returns immediately and the outcome is read back from the export settings.
     * @summary Starts an export outside the schedule.
     * @param {object} body Empty: an unscheduled export takes no arguments and uses the stored settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceRunSalesExportNow(
      body: object,
      options?: any,
    ): AxiosPromise<V1RunSalesExportNowResponse> {
      return localVarFp
        .analyticsServiceRunSalesExportNow(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to administrators and the head of sales, because the setting decides where company data leaves for.
     * @summary Changes the export destination folder, the schedule, the data window, or switches the export off.
     * @param {V1UpdateSalesExportSettingsRequest} body New export settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceUpdateSalesExportSettings(
      body: V1UpdateSalesExportSettingsRequest,
      options?: any,
    ): AxiosPromise<V1SalesExportSettings> {
      return localVarFp
        .analyticsServiceUpdateSalesExportSettings(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replaces those settings.
     * @param {V1UpdateSalesReportSettingsRequest} body New display settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceUpdateSalesReportSettings(
      body: V1UpdateSalesReportSettingsRequest,
      options?: any,
    ): AxiosPromise<V1SalesReportSettings> {
      return localVarFp
        .analyticsServiceUpdateSalesReportSettings(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a goal, or rewrites the amount of the goal that already covers the same dates.
     * @param {V1UpsertSalesTargetRequest} body A goal to add, or to rewrite if one already covers the same dates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceUpsertSalesTarget(
      body: V1UpsertSalesTargetRequest,
      options?: any,
    ): AxiosPromise<V1SalesTarget> {
      return localVarFp
        .analyticsServiceUpsertSalesTarget(body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AnalyticsServiceApi - object-oriented interface
 * @export
 * @class AnalyticsServiceApi
 * @extends {BaseAPI}
 */
export class AnalyticsServiceApi extends BaseAPI {
  /**
   *
   * @summary Removes a goal.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceDeleteSalesTarget(id: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceDeleteSalesTarget(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators.
   * @summary Returns per-agent sales figures: clients, deals, wins, deposits, client-to-deposit conversion, revenue and the forecast reward.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentDealsReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentDealsReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators, the head of sales and the CEO see every agent; a manager sees only the agents they supervise.
   * @summary Returns presentation statistics for every visible agent at once: one row per agent plus the combined totals and daily trend.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentPresentationReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentPresentationReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators, the head of sales and the CEO may request any agent; a manager only the agents they supervise.
   * @summary Returns the same presentation statistics for one named agent, as shown on the agent card in the CRM.
   * @param {string} agentId
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentPresentationStats(
    agentId: string,
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentPresentationStats(
        agentId,
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators.
   * @summary Returns agent deals grouped by the state of their reward — expected, approved, paid, disputed or cancelled — with the forecast amount.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentRewardReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentRewardReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * This is what a campaign card shows next to its links, so it is readable by whoever runs the campaigns — not only by the roles that see the full marketing report. Internal note: requires landings:read.
   * @summary Returns every campaign with its tagged links, each with its own views and leads.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [campaign] Empty means every campaign seen in the facts; a value narrows it to one.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetCampaignReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    campaign?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetCampaignReport(periodPeriod, periodFrom, periodTo, campaign, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators.
   * @summary Returns how well each way of acquiring a client performs: clients, deals, wins and conversion per source type.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetClientSourceReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetClientSourceReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the KPIs of the clients screen: totals, new clients, how many have an active deal and how many have no manager assigned.
   * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetClientsKpi(period?: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetClientsKpi(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators.
   * @summary Returns the same sales figures aggregated per partner company, with the number of agents each company contributed.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetCompanyDealsReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetCompanyDealsReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: DEV-280 replaced three fan-out calls and an N+1 on the lead-source donut with this method.
   * @summary Returns every dashboard metric in one call: headline KPIs for clients, listings, deals and conversion, their sparklines, the lead-source breakdown and the monthly deal chart.
   * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetDashboardMetrics(period?: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetDashboardMetrics(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the KPIs of the deals screen, including the per-stage breakdown the kanban board uses for its column headers.
   * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetDealsKpi(period?: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetDealsKpi(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the sales funnel: how many deals reached each stage in the period, and the conversion between stages.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetFunnel(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetFunnel(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Answers the question the report above cannot: not \"how many came from Telegram\" but \"which of the three campaigns worked\". Internal note: restricted to the same roles as the conversion report.
   * @summary Breaks one landing page down by the campaign tags its traffic arrived with.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [landingSlug] Empty means every landing page at once, which is how one campaign spread over several pages is read.
   * @param {string} [groupBy] Which tag the rows are grouped by: \&quot;source\&quot;, \&quot;medium\&quot;, \&quot;campaign\&quot; or \&quot;content\&quot; — the utm_* parameter without its prefix. Empty means \&quot;source\&quot;, which is what a campaign is read by first. Spelled as a string for the same reason PeriodFilter.period is: this contract has no enums.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLandingAttributionReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    landingSlug?: string,
    groupBy?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLandingAttributionReport(
        periodPeriod,
        periodFrom,
        periodTo,
        landingSlug,
        groupBy,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * This is a report about a shared marketing asset, so it carries no per-manager scope. Internal note: restricted to administrators, the head of sales and the CEO.
   * @summary Returns leads against page views for every landing page in the period.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLandingConversionReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLandingConversionReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Days are cut in Asia/Ho_Chi_Minh, where the traffic is: in UTC an evening campaign would land half in one day and half in the next. Internal note: restricted to the same roles as the conversion report.
   * @summary Returns views and leads day by day, so that a spike has a shape and a date instead of being a single number for the whole period.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [landingSlug] Empty means every landing page at once.
   * @param {string} [campaign] Empty means every campaign at once; a value narrows the series down to one utm_campaign, which is how a campaign card draws its own traffic.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLandingDailySeries(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    landingSlug?: string,
    campaign?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLandingDailySeries(
        periodPeriod,
        periodFrom,
        periodTo,
        landingSlug,
        campaign,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Answers what a view count cannot: a page nobody scrolls past the first screen and a page everyone reads to the end have the same views. Internal note: counters of one\'s own page, so requires landings:read — the same level as the campaign report.
   * @summary Returns what visitors did on a landing page: how far they scrolled, what they tapped, how often they sent the form.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [landingSlug] Empty means every landing page at once.
   * @param {string} [campaign] Empty means every campaign at once; a value narrows the counts down to one utm_campaign.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLandingEventsReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    landingSlug?: string,
    campaign?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLandingEventsReport(
        periodPeriod,
        periodFrom,
        periodTo,
        landingSlug,
        campaign,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns how clients, deals and revenue are distributed across lead sources.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLeadSourcesReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLeadSourcesReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Rows carry manager identifiers only — resolve the names through the auth service. Internal note: restricted to the head of sales and administrators.
   * @summary Returns how managers work rather than how much they sell: which funnel stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
   * @param {string} [from] Start of the window. Empty means no lower bound.
   * @param {string} [to] End of the window. Empty means no upper bound.
   * @param {Array<string>} [managerIds] Managers to include. Empty means every manager the caller may see.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetManagerAnalytics(
    from?: string,
    to?: string,
    managerIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetManagerAnalytics(from, to, managerIds, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators.
   * @summary Ranks managers by won deals, win rate and revenue.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetManagerLeaderboard(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetManagerLeaderboard(
        periodPeriod,
        periodFrom,
        periodTo,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns presentation statistics for the calling agent: how many were created, sent and viewed, the conversion between sent and viewed, the daily trend and the best performing presentations.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetMyPresentationStats(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetMyPresentationStats(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns revenue from won deals, grouped by time bucket, by manager or by lead source.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [groupBy] Grouping: a time bucket (\&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;) or a category (\&quot;manager\&quot;, \&quot;lead_source\&quot;).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetRevenueReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    groupBy?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetRevenueReport(periodPeriod, periodFrom, periodTo, groupBy, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: readable by everyone who can read the report itself.
   * @summary Returns where the sales report is exported to, how often, and how the last export ended.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetSalesExportSettings(options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetSalesExportSettings(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Money is not recomputed here. Every reward is already calculated in the deals service and travels through as is, so the card of a deal and this report can never disagree. Internal note: DEV-1880, ADR-0052; restricted to the head of sales, administrators and the CEO.
   * @summary Returns the \"Deals and revenue\" report: the plan and the fact of one month inside a target period, the same numbers week by week, and the deals they are made of.
   * @param {string} [month] Any moment inside the month. Empty means the current one.
   * @param {boolean} [includeExcluded] Count the deals of managers kept out of payroll — the leadership. They are left out by default, exactly as in the manual report.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetSalesFinanceReport(
    month?: string,
    includeExcluded?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetSalesFinanceReport(month, includeExcluded, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * It is a separate call rather than a block of the report because generation takes seconds to tens of seconds, and the screen must not wait for it. Internal note: restricted to the head of sales, administrators and the CEO.
   * @summary Returns a short written conclusion — four to six findings a model draws from the same aggregates the sales report is built on.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {boolean} [refresh] Generate again even when a conclusion for these numbers already exists. This backs the \&quot;refresh\&quot; button: the numbers are the same, but the wording may be worth another try.
   * @param {boolean} [cacheOnly] Answer from the cache only, never call the model. Exports run under their own deadline: waiting for a fresh conclusion would cost them the file, so they take the cached one or go without the block.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetSalesInsights(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    refresh?: boolean,
    cacheOnly?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetSalesInsights(
        periodPeriod,
        periodFrom,
        periodTo,
        refresh,
        cacheOnly,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: DEV-1067 and ADR-0034 describe the classification; restricted to the head of sales, administrators and the CEO.
   * @summary Returns the sales department report: how leads are distributed across states, how the flow changed month over month, which sources performed, and how good the leads coming from agents were.
   * @param {string} [periodPeriod] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Empty means \&quot;month\&quot;.
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetSalesReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetSalesReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns how the report shows money: the currency and the rate used to compare a goal in dollars with revenue in dong.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetSalesReportSettings(options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetSalesReportSettings(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the sales goals, newest period first.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceListSalesTargets(options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceListSalesTargets(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * The run is idempotent and asynchronous: the call returns as soon as the reconciliation starts, and reads the source services under the caller\'s own token. Internal note: restricted to the head of sales and administrators.
   * @summary Rebuilds the read model from the source services.
   * @param {V1RunReconcileRequest} body What to reconcile.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceRunReconcile(
    body: V1RunReconcileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceRunReconcile(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Asynchronous: building the file with its written conclusion and uploading it does not fit into the gateway timeout, so the call returns immediately and the outcome is read back from the export settings.
   * @summary Starts an export outside the schedule.
   * @param {object} body Empty: an unscheduled export takes no arguments and uses the stored settings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceRunSalesExportNow(body: object, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceRunSalesExportNow(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to administrators and the head of sales, because the setting decides where company data leaves for.
   * @summary Changes the export destination folder, the schedule, the data window, or switches the export off.
   * @param {V1UpdateSalesExportSettingsRequest} body New export settings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceUpdateSalesExportSettings(
    body: V1UpdateSalesExportSettingsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceUpdateSalesExportSettings(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replaces those settings.
   * @param {V1UpdateSalesReportSettingsRequest} body New display settings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceUpdateSalesReportSettings(
    body: V1UpdateSalesReportSettingsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceUpdateSalesReportSettings(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a goal, or rewrites the amount of the goal that already covers the same dates.
   * @param {V1UpsertSalesTargetRequest} body A goal to add, or to rewrite if one already covers the same dates.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceUpsertSalesTarget(
    body: V1UpsertSalesTargetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceUpsertSalesTarget(body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
